export function mockStandalone() {
  // tslint:disable-next-line:no-collapsible-if
  if (process.env.NODE_ENV === 'development') {
    if (window.top === window) {
      const { getFakeSiteColor, getFakeStyleParams } = require('./fakeData');

      window.Wix.Styles.getStyleParams = cb => {
        const data = getFakeStyleParams();
        cb(data);
        return data;
      };
      window.Wix.Styles.getSiteColors = cb => {
        const data = getFakeSiteColor();
        cb(data);
        return data;
      };
      window.Wix.Data.Public.get = (key, opts, resolve, reject) => {
        switch (key) {
          case 'title':
            return resolve({ title: 'Peter' });
          case 'name':
            return resolve({ name: 'Peter' });
          default:
            return reject();
        }
      };
    }
  }
}
